import { Tile as TileLayer } from 'ol/layer';
import ImageTile from 'ol/source/ImageTile';
import { LoaderOptions } from 'ol/source/DataTile';

const apiBaseUrl = (window as any)?._env_?.REACT_APP_API_BASE_URL
    ?? process.env.REACT_APP_API_BASE_URL
    ?? '';
  
const getGameCodeFromUrl = (): string => {
  const match = window.location.pathname.match(/\/games\/([^/]+)/);
  return match?.[1] ?? '';
};

export const createAzureLayer = (): TileLayer => {
  return new TileLayer({
    source: new ImageTile({
      crossOrigin: 'anonymous',
      maxZoom: 19,
      wrapX: false,
      loader: (z, x, y, loaderOptions: LoaderOptions) => {
        const gameCode = getGameCodeFromUrl();
        return fetch(
          `${apiBaseUrl}/api/map/azureTile?zoom=${z}&x=${x}&y=${y}`,
          {
            headers: {
              'X-Game-Code': gameCode
            },
            signal: loaderOptions?.signal
          }
        )
          .then(response => {
            if (!response.ok) {
              throw new Error(`Tile request failed: ${response.status}`);
            }
            return response.blob();
          })
          .then(blob => {
            return new Promise<HTMLImageElement>((resolve, reject) => {
              const img = new Image();
              const objectUrl = URL.createObjectURL(blob);
              img.onload = () => {
                URL.revokeObjectURL(objectUrl);
                resolve(img);
              };
              img.onerror = (e) => {
                URL.revokeObjectURL(objectUrl);
                reject(e);
              };
              img.src = objectUrl;
            });
          });
      }
    })
  });
};